import { Link } from 'react-router-dom';
import { featuredEvents } from '@/mocks/homeData';

export default function FeaturedEvents() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门赛事
            </h2>
            <p className="text-sm text-foreground-600">
              实时赔率更新，把握每一个精彩瞬间
            </p>
          </div>
          <Link
            to="/category/football"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部赛事
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[800px] text-sm">
            <thead>
              <tr className="border-b border-background-200/60">
                <th className="text-left py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">赛事</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">时间</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">主队</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">赔率</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">平局</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">客队</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">赔率</th>
                <th className="text-center py-3 px-2 text-xs font-medium text-foreground-500 whitespace-nowrap">状态</th>
              </tr>
            </thead>
            <tbody>
              {featuredEvents.map((event) => (
                <tr key={event.id} className="border-b border-background-100/80 hover:bg-background-100/50 transition-colors duration-150">
                  <td className="py-3 px-2">
                    <div className="flex items-center gap-2">
                      {event.popular && (
                        <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-800 rounded whitespace-nowrap">热门</span>
                      )}
                      <span className="text-xs text-foreground-600 whitespace-nowrap">{event.league}</span>
                    </div>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="text-xs text-foreground-600 whitespace-nowrap">{event.time}</span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">{event.homeTeam}</span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="inline-block px-2 py-0.5 text-xs font-semibold bg-primary-100 text-primary-700 rounded whitespace-nowrap">{event.homeOdds}</span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    {event.drawOdds > 0 ? (
                      <span className="inline-block px-2 py-0.5 text-xs font-medium bg-background-100 text-foreground-600 rounded whitespace-nowrap">{event.drawOdds}</span>
                    ) : (
                      <span className="text-xs text-foreground-400">-</span>
                    )}
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">{event.awayTeam}</span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="inline-block px-2 py-0.5 text-xs font-semibold bg-background-100 text-foreground-700 rounded whitespace-nowrap">{event.awayOdds}</span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                      event.status === 'live'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {event.status === 'live' && (
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse inline-block"></span>
                      )}
                      {event.status === 'live' ? '进行中' : '即将开始'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}